import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { cloneDeep } from "lodash";

@Component({
  selector: "app-filter-table-dialog",
  templateUrl: "./filter-table-dialog.component.html",
  styleUrls: ["./filter-table-dialog.component.scss"],
})
export class FilterTableDialogComponent implements OnInit {
  columns!: any[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.columns = cloneDeep(this.data.columns);
  }
}
